
<div class="service-card d-flex flex-wrap flex-sm-nowrap justify-content-center justify-content-sm-start align-items-center h-100">
    <a :href="storeUrl" class="image col-md-4">
        <img v-if="item.thumbnail" :src="item.thumbnail.public_path" class="service-item-img" :alt="item.thumbnail.alt"/>
    </a>

    <div class="w-100">
        <a :href="storeUrl" class="service-item-title mx-4">{{ item.title }}</a>
        
        <div class="info-container mx-2">
            <div v-if="terminals && terminals.length > 0">
                <div class="d-flex">
                    <i class="fas service-item-icon fa-map-marker-alt"></i>
                    <label class="mx-1 section-title text-nowrap" v-html="configTexts.ubicationText"></label>
                </div>

                <div class="mx-3">
                    <template v-for="(terminal, index) in terminals">
                        <label>
                            {{terminal['title']}} 
                            {{terminal.items && terminal.items.length > 0 ? `: Local ${terminal.items.map(x => x.title).join('-')}` : ''}}
                        </label>
                    </template>
                </div>
            </div>

            <div v-if="contact && contact.length > 0">
                <div class="d-flex">
                    <i class="far service-item-icon fa-envelope"></i>
                    <label class="mx-1 section-title" v-html="configTexts.contactText"></label>
                </div>

                <div class="mx-3 text-wrap">
                    <template v-for="(cnt, index) in contact">
                        <a v-if="cnt.includes('http')" :href="cnt" class="contact-link" target="_blank">{{cnt}}</a>
                        <label v-else class="text-wrap">{{cnt}}</label>
                    </template>
                </div>
            </div>

            <div v-if="schedules && schedules.length > 0">
                <div class="d-flex">
                    <i class="fas fa-clock me-1"></i>
                    <label class="mx-1 section-title" v-html="configTexts.schedulesText"></label>
                </div>

                <div class="mx-3">
                    <template v-for="(schedule, index) in schedules">
                        <label>{{schedule['day']}}: {{schedule['start_at']}} - {{schedule['ends_at']}}</label>
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>
